import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiXCircle, FiCheckCircle } = FiIcons;

const Abgrenzung = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">Was wir explizit NICHT tun</h2>
            <p className="text-lg text-gray-600">
              Positionierung entsteht durch Abgrenzung. Wir sind keine Umsetzungsgehilfen, sondern Ihre Architekten.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-red-600 flex items-center">
                <SafeIcon icon={FiXCircle} className="mr-3" /> Keine klassische Agentur
              </h3>
              <ul className="space-y-4 text-gray-600">
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-3 mt-2"></div>
                  Keine Bot-Agentur (wir "bauen" keine Chatbots)
                </li>
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-3 mt-2"></div>
                  Keine reine Toolberatung
                </li>
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-3 mt-2"></div>
                  Wir verkaufen keine Tools.
                </li>
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-3 mt-2"></div>
                  Keine Softwareentwicklung als Kernleistung
                </li>
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-3 mt-2"></div>
                  Keine "Wir automatisieren alles"-Positionierung
                </li>
              </ul>
            </div>

            <div className="space-y-6">
              <h3 className="text-xl font-bold text-azure-600 flex items-center">
                <SafeIcon icon={FiCheckCircle} className="mr-3" /> Unser Fokus
              </h3>
              <ul className="space-y-4 text-gray-600">
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-azure-600 rounded-full mr-3 mt-2"></div>
                  Herstellung von System-Architektur & Prozessklarheit
                </li>
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-azure-600 rounded-full mr-3 mt-2"></div>
                  Analyse der Entscheidungsqualität im Unternehmen
                </li>
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-azure-600 rounded-full mr-3 mt-2"></div>
                  Entwurf von belastbaren System-Architekturen
                </li>
                <li className="flex items-start">
                  <div className="w-1.5 h-1.5 bg-azure-600 rounded-full mr-3 mt-2"></div>
                  Verantwortung in der System-Architektur definieren
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Abgrenzung;